export const colors = {
  primary: "#0078d4",
  primaryHover: "#106ebe",
  primarySoft: "#eff6fc",
  text: "#323130",
  textMuted: "#605e5c",
  textSubtle: "#8a8886",
  border: "#e1dfdd",
  surface: "#ffffff",
  surfaceAlt: "#f3f2f1",
  danger: "#a4262c",
  focus: "#0078d4",
} as const;
